<div class="routine-container">
  <div class="d-flex flex-column justify-content-center">
    <div class="d-flex">
      <span>Rutina de &nbsp;</span
      ><span class="fw-bold">{{ autoassignedRoutine.name }}</span>
    </div>

    <span class="created-time" *ngIf="hoursDifference! < 1"
      >Creada hace menos de una hora</span
    >

    <span class="created-time" *ngIf="hoursDifference! >= 1"
      >Creada hace {{ hoursDifference }} horas</span
    >
  </div>
  <i class="bi bi-chevron-right" style="font-size: 32px"></i>
</div>
